"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInstallmentsSelector = void 0;

var _react = require("react");

var _constants = require("../../../constants");

var _hooks = require("../../../hooks");

var _utils = require("../../../utils");

var useInstallmentsSelector = function useInstallmentsSelector(_ref) {
  var selectedBy = _ref.selectedBy,
      selectedInstallment = _ref.selectedInstallment;
  var installmentsContainerElement = (0, _hooks.useIsolateTouch)();
  var installmentInfo = (0, _react.useMemo)(function () {
    return "".concat(selectedInstallment.installmentsQuantity, "x de ").concat((0, _utils.formatCurrency)(selectedInstallment.installmentsAmount));
  }, [selectedInstallment]);
  var monthlyFeeObservations = (0, _react.useMemo)(function () {
    return "com juros de ".concat((0, _utils.formatPercentage)(selectedInstallment.interestRateMonthly), " ao m\xEAs");
  }, [selectedInstallment]);
  (0, _react.useEffect)(function () {
    if (selectedBy === _constants.OrderBy.MAX) {
      var element = installmentsContainerElement.current;

      var _element$getBoundingC = element.getBoundingClientRect(),
          width = _element$getBoundingC.width;

      element.scrollLeft = width;
    }
  }, []);
  return {
    installmentsContainerElement: installmentsContainerElement,
    installmentInfo: installmentInfo,
    monthlyFeeObservations: monthlyFeeObservations
  };
};

exports.useInstallmentsSelector = useInstallmentsSelector;